

import { formatFormula } from '~/fc/Helpers/UnitHelpers';
import { lazyLoadComponentIfVisible } from '~/fc/lazy-load-component';
import UnitConverter from /* webpackChunkName: "UnitConverter" */ '../partials/unit/UnitConverter'
import Skeleton from '~/components/Skeleton.vue';

export default {
    name: 'UnitSingleTemplate',
    components: {
        Skeleton,
        UnitConverter,
        Formula: () => import(/* webpackChunkName: "Formula" */ '../partials/unit/Formula'),
        AdsSide: () => import(/* webpackChunkName: "AdsSide" */ '../partials/ads/AdsSide'),
        AdInPage: () => import(/* webpackChunkName: "AdInPage" */ '../partials/ads/AdInPage'),
        SecurityAndCompliance: () => import(/* webpackChunkName: "SecurityAndCompliance" */ "~/components/ui/SecurityAndCompliance"),
        UnitGuide: lazyLoadComponentIfVisible({componentLoader: () => import(/* webpackChunkName: "UnitGuide" */ '../partials/unit/UnitGuide'), loadingComponent: Skeleton }),
        UnitConversionTable: lazyLoadComponentIfVisible({componentLoader: () => import(/* webpackChunkName: "UnitConversionTable" */ '../partials/unit/UnitConversionTable'), loadingComponent: Skeleton}),
        UnitLinks: lazyLoadComponentIfVisible({componentLoader: () => import(/* webpackChunkName: "UnitLinks" */ '../partials/unit/UnitLinks'), loadingComponent: Skeleton}),
        TryFree: lazyLoadComponentIfVisible({componentLoader: () => import(/* webpackChunkName: "TryFree" */ '../partials/page/TryFree'), loadingComponent: Skeleton})
    },
    data: () => ({
        formula: '',
        showLoader: true
    }),
    computed: {
        info() {
            return this.$store.state.info
        },
        formattedFormula() {
            return formatFormula(this.formula)
        },
        isMobile() { return this.$store.state.store.isMobile }
    },
    mounted() {
        setTimeout(() => {
            this.showLoader = false
        }, 3000);
    },
}
